import type { TFunction } from "i18next";

import { SUBSCRIPTION_BILLING_PERIOD } from "@/constants/subscriptions";

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getSubscriptionCardLabel = (period: string | undefined, t: TFunction): string => {
  const billingPeriodLabel: Record<string, string> = {
    [SUBSCRIPTION_BILLING_PERIOD.MONTHLY]: t("common:month"),
    [SUBSCRIPTION_BILLING_PERIOD.QUARTERLY]: t("common:quarter"),
    [SUBSCRIPTION_BILLING_PERIOD.ANNUAL]: t("common:year"),
  };

  return period ? billingPeriodLabel[period] : "";
};

export default getSubscriptionCardLabel;
